<template>
  <div class="row">
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else>
      <div class="row">
        <breadcrumb-component
          :moduleTitle="'Service management'"
          :mainTitle="'Server'"
          :subTitle="'Server create'"
        />
        <div class="col-md-12" v-if="step == 1">
          <div class="card card_full_window vm_create_page">
            <div class="card-body">
              <div class="common_content_wrap no_left_content">
                <div class="common_content_right">
                  <div class="vm_list_content">
                    <div class="d_flex_start pt_10">
                      <h6 class="d_flex_start w-100 common_subtitle">
                        Select OS
                      </h6>
                    </div>
                    <div class="os_list pt_10 pb_10">
                      <div
                        class="os_list_inner"
                        :class="{ active: form.os_type == 'ubuntu' }"
                        @click.prevent="changeOsType('ubuntu')"
                      >
                        <div class="inner_wrap">
                          <div class="text">UBUNTU</div>
                          <div class="image">
                            <img
                              src="assets/media/images/service-page/os-list6.png"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        class="os_list_inner"
                        :class="{ active: form.os_type == 'debian' }"
                        @click.prevent="changeOsType('debian')"
                      >
                        <div class="inner_wrap">
                          <div class="text">DEBIAN</div>
                          <div class="image">
                            <img
                              src="assets/media/images/service-page/os-list2.png"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        class="os_list_inner"
                        :class="{ active: form.os_type == 'win' }"
                        @click.prevent="changeOsType('win')"
                      >
                        <div class="inner_wrap">
                          <div class="text">WINDOWS</div>
                          <div class="image">
                            <img
                              src="assets/media/images/service-page/os-list7.png"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        class="os_list_inner"
                        :class="{ active: form.os_type == 'rocky' }"
                        @click.prevent="changeOsType('rocky')"
                      >
                        <div class="inner_wrap">
                          <div class="text">ROCKY</div>
                          <div class="image">
                            <img
                              src="assets/media/images/service-page/os-list5.png"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="d_flex_start pt_20 pb_10">
                      <h6 class="d_flex_start w-100 common_subtitle">
                        Select Version
                      </h6>
                    </div>
                    <div class="common_dropdown dropdown_no_radius pb_20">
                      <div class="btn-group dropdown-center dropdown-fill-text">
                        <button
                          type="button"
                          class="btn btn-secondary dropdown-toggle"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span v-if="selectedProductType">{{
                            selectedProductType.template_desc
                          }}</span>
                        </button>
                        <ul class="dropdown-menu no_arrow">
                          <li
                            v-for="(
                              serverProductType, index
                            ) in serverProductTypes"
                            :key="'server_region_' + index"
                            @click.prevent="
                              changeProductType(serverProductType)
                            "
                          >
                            <button class="dropdown-item" type="button">
                              <span>{{ serverProductType.template_desc }}</span>
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="d_flex_end custom_border_top mt_20 pt_20">
                      <button
                        type="button"
                        class="btn btn-outline-danger mr_5"
                        @click.prevent="cancelOperation()"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary btn-md width_100p"
                        @click.prevent="stepChange(2)"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12" v-if="step == 2">
          <div class="card card_full_window vm_checkout_page">
            <div class="card-body">
              <div class="no_left_content">
                <h5 class="common_subtitle pb_20 border-lightgray-bottom mb_20">
                  VM Configuration
                </h5>
                <div class="vm_checkout_content">
                  <div class="vm_checkout_left">
                    <div class="mb-3">
                      <label for="server_name" class="col-form-label"
                        >VM Name</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="server_name"
                        v-model="form.server_name"
                      />
                      <v-errors :errors="errorFor('server_name')"></v-errors>
                    </div>

                    <div class="mb-3">
                      <label for="server_product_type_id" class="col-form-label"
                        >Specification (Model Core RAM -- Space)</label
                      >
                      <select
                        class="form-select"
                        id="server_product_type_id"
                        v-model="form.server_product_type_id"
                        @change="changeSpecification"
                      >
                        <option
                          v-for="(osProductType, index) in osProductTypes"
                          :key="'os_product_type_' + index"
                          :value="osProductType.id"
                        >
                          {{ osProductType.service_offering_desc }} --
                          {{ osProductType.disk_offering_desc }}
                        </option>
                      </select>
                      <v-errors
                        :errors="errorFor('server_product_type_id')"
                      ></v-errors>
                    </div>
                    <!--                                    <div class="mb-3">
                                      <label for="ssh_keypair_id" class="col-form-label">Ssh keypair</label>
                                      <div class="d-flex align-items-center">
                                        <select class="form-select me-4" id="ssh_keypair_id" v-model="form.ssh_keypair_id">
                                            <option value="">Select ssh keypair</option>
                                            <option  v-for="(sshKeypair, index) in sshKeypairs" :key="'ssh_keypair_'+index" :value="sshKeypair.id">
                                                {{ sshKeypair.name }}
                                            </option>
                                        </select>
                                        <button class="btn btn-outline-primary btn-sm width_100p" @click="openAddSshModal">+ Add</button>
                                        <v-errors :errors="errorFor('ssh_keypair_id')"></v-errors>
                                      </div>
                                    </div>-->
                    <div class="mb-3">
                      <label for="inputEmail3" class="col-form-label"
                        >Billing type</label
                      >
                      <select class="form-select" v-model="form.billing_type">
                        <option value="monthly">Monthly</option>
                        <option value="hourly">Hourly</option>
                      </select>
                      <v-errors :errors="errorFor('billing_type')"></v-errors>
                    </div>
                  </div>
                  <div class="vm_checkout_right">
                    <div class="vm_checkout_right_wrap">
                      <h5 class="common_subtitle">Estimated Bill</h5>
                      <div class="checkout_right_inner">
                        <div class="d_flex_btwn inner_title">
                          <span>Server details</span>
                          <span v-if="form.billing_type == 'monthly'"
                            >￦ {{ selectedOsProductType?.monthly_price }}</span
                          >
                          <span v-else
                            >￦ {{ selectedOsProductType?.hourly_price }}</span
                          >
                        </div>
                        <div class="vm_checkout_table">
                          <table class="table">
                            <tbody>
                              <tr>
                                <td>Operating system</td>
                                <td>
                                  {{ selectedProductType?.template_desc }}
                                </td>
                              </tr>
                              <tr>
                                <td>Specification</td>
                                <td>
                                  {{
                                    selectedOsProductType?.service_offering_desc
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td>Space</td>
                                <td>
                                  {{
                                    selectedOsProductType?.disk_offering_desc
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="checkout_subtotal">
                          <template v-if="form.billing_type == 'monthly'">
                            <p class="mb_5">Total estimated bill(1 month)</p>
                            <h2 class="subtotal">
                              ￦ {{ selectedOsProductType?.monthly_price }}
                            </h2>
                          </template>
                          <template v-else>
                            <p class="mb_5">Total estimated bill(1 hour)</p>
                            <h2 class="subtotal">
                              ￦ {{ selectedOsProductType?.hourly_price }}
                            </h2>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d_flex_btwn custom_border_top mt_20 pt_20 pb_20">
                <div class="d_flex_start">
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-md width_100p"
                    @click.prevent="stepChange(1)"
                  >
                    Back
                  </button>
                </div>
                <div class="d_flex_start">
                  <button
                    type="button"
                    class="btn btn-outline-danger mr_5"
                    @click.prevent="cancelOperation()"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary btn-md width_100p"
                    :disabled="lyLoading"
                    @click.prevent="submit"
                  >
                    Launch
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LoaderMaskComponent from '@/components/LoaderMaskComponent.vue';
import BreadcrumbComponent from '@/components/shared/BreadcrumbComponent.vue';
export default {
  name: 'VlanCloudServerForm',
  components: { LoaderMaskComponent, BreadcrumbComponent },
  data() {
    return {
      lyLoading: false,
      selectedPlatform: null,
      step: 1,
      form: {
        server_name: '',
        os_type: 'ubuntu',
        server_product_type_id: '',
        volume_type: 'HDD',
        volume_size: '50G',
        billing_type: 'hourly',
      },
      serverRegions: [],
      sshKeypairs: [],
      selectedRegion: null,
      serverProductTypes: [],
      selectedProductType: null,
      osProductTypes: [],
      selectedOsProductType: null,
      serverDTypes: [],
      selectedDType: null,
      serverDTypeChildren: [],
      serverDTypeChildrenList: null,
      serverDTypeChildrenLists: [],
      osDProductTypes: [],
      selectedDOsProductType: null,
      ktTiers: [],
      ktDPriceSettings: [],
      dImages: [],
      isShowContactModal: false,
    };
  },
  computed: {
    ...mapGetters({
      customer: 'auth/getUserInfo',
    }),
    generatedMonthlyPrice() {
      if (this.form.volume_type == 'HDD') {
        let priceSetting = this.ktDPriceSettings.filter(
          (price) => price.type == 'HDD'
        );
        if (this.form.volume_size == 50) {
          return (
            this.selectedDOsProductType.monthly_price +
            priceSetting[0].monthly_add_price
          );
        } else if (this.form.volume_size == 100) {
          return (
            this.selectedDOsProductType.monthly_price +
            priceSetting[0].monthly_add_price +
            priceSetting[0].monthly_extra_price
          );
        } else {
          return 0;
        }
      } else {
        let priceSetting = this.ktDPriceSettings.filter(
          (price) => price.type == 'SSD'
        );

        if (this.form.volume_size == 50) {
          return (
            this.selectedDOsProductType.monthly_price +
            priceSetting[0].monthly_add_price
          );
        } else if (this.form.volume_size == 100) {
          return (
            this.selectedDOsProductType.monthly_price +
            priceSetting[0].monthly_add_price +
            priceSetting[0].monthly_extra_price
          );
        } else {
          return 0;
        }
      }
    },
    generatedHourlyPrice() {
      if (this.form.volume_type == 'HDD') {
        let priceSetting = this.ktDPriceSettings.filter(
          (price) => price.type == 'HDD'
        );
        if (this.form.volume_size == 50) {
          return (
            this.selectedDOsProductType.hourly_price +
            priceSetting[0].hourly_add_price
          );
        } else if (this.form.volume_size == 100) {
          return (
            this.selectedDOsProductType.hourly_price +
            priceSetting[0].hourly_add_price +
            priceSetting[0].hourly_extra_price
          );
        } else {
          return 0;
        }
      } else {
        let priceSetting = this.ktDPriceSettings.filter(
          (price) => price.type == 'SSD'
        );
        if (this.form.volume_size == 50) {
          return (
            this.selectedDOsProductType.hourly_price +
            priceSetting[0].hourly_add_price
          );
        } else if (this.form.volume_size == 100) {
          return (
            this.selectedDOsProductType.hourly_price +
            priceSetting[0].hourly_add_price +
            priceSetting[0].hourly_extra_price
          );
        } else {
          return 0;
        }
      }
    },
  },
  watch: {
    customer() {},
  },
  mounted() {
    this.fetchServerProductTypes();
  },
  methods: {
    changeOsType(osType) {
      this.form.os_type = osType;
      this.fetchServerProductTypes();
    },
    fetchServerProductTypes() {
      let formData = {
        os_type: this.form.os_type,
      };
      this.axios
        .post('/get-proxmox-server-product-types', formData)
        .then(({ data }) => {
          this.serverProductTypes = data;
          if (this.serverProductTypes.length > 0) {
            this.selectedProductType = this.serverProductTypes[0];
            this.form.volume_size = this.selectedProductType.disk_offering_desc;
          } else {
            this.selectedProductType = null;
          }
        });
    },
    changeProductType(productType) {
      this.selectedProductType = productType;
    },
    stepChange(value) {
      if (value == 2) {
        let formData = {
          server_region_id: this.form.server_region_id,
          template_desc: this.selectedProductType?.template_desc,
        };
        this.axios
          .post('/proxmox/get-os-product-types', formData)
          .then(({ data }) => {
            this.osProductTypes = data;
            if (this.osProductTypes.length > 0) {
              this.selectedOsProductType = this.osProductTypes[0];
              this.form.server_product_type_id = this.selectedOsProductType.id;
            } else {
              this.selectedOsProductType = null;
              this.form.server_product_type_id = '';
            }
          });
      } else {
        if (this.serverDTypeChildrenList) {
          this.osDProductTypes = this.serverDTypeChildrenList.product_types;
          if (this.osDProductTypes.length > 0) {
            this.selectedDOsProductType = this.osDProductTypes[0];
            this.form.kt_d_product_type_id = this.selectedDOsProductType.id;
          } else {
            this.selectedDOsProductType = null;
            this.form.kt_d_product_type_id = '';
          }
        } else {
          this.osDProductTypes = [];
          this.selectedDOsProductType = null;
          this.form.kt_d_product_type_id = '';
        }
      }
      this.step = value;
    },
    changeSpecification() {
      let result = this.osProductTypes.filter(
        (e) => e.id == this.form.server_product_type_id
      );
      this.selectedOsProductType = result[0];
    },

    cancelOperation() {
      this.$swal({
        title: 'Are you sure want to cancel?',
        text: 'It will stop server creation!',
        showCancelButton: true,
        confirmButtonText: 'Yes, cancel it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$router.push('cloud-servers');
        }
      });
    },
    async submit() {
      try {
        this.allErrors = null;
        this.lyLoading = true;

        /*const anotherApiCallResponse = await this.axios.post('/check-server-name-availability', {
                      server_name: this.form.server_name
                    });*/

        const response = await this.axios.post(
          '/proxmox/create-vm-from-template',
          this.form
        );

        if (response.data.success) {
          this.showSuccessMsg(response.data.message);
          this.$router.push('cloud-servers');
        } else {
          this.$swal({
            text: response.data.message,
            showCancelButton: false,
            confirmButtonText: 'Close!',
            confirmButtonColor: '#dd4b39',
            reverseButtons: true,
          });
        }
      } catch (err) {
        this.allErrors = err.response?.data?.errors || null;
        this.showFailMsg(err.response?.data?.message || 'An error occurred');
      } finally {
        this.lyLoading = false;
      }
    },

    closeModal() {
      this.isShowContactModal = false;
    },
    setCreatedRecord(record) {
      this.form.ssh_keypair_id = record.id;
    },
  },
};
</script>
<style scoped></style>
